import { useEffect, useState } from "react";
import { toast } from "sonner";
import API, { formatApiError } from "../../../lib/api";
import { Switch } from "../../ui/switch";
import { ShieldWarning } from "@phosphor-icons/react";

/** Admin switch: flag a job as high-risk so nobody can mark Arrived until a RAMS naming them is issued and signed. */
export function RamsRequiredToggle({ jobId, value, onChange, compact }) {
  const [on, setOn] = useState(!!value);
  const [busy, setBusy] = useState(false);
  useEffect(() => setOn(!!value), [value]);
  const toggle = async (next) => {
    setBusy(true); setOn(next);
    try {
      await API.put(`/hs/jobs/${jobId}/rams-required`, { required: next });
      toast.success(next ? "Flagged high-risk — engineers can't arrive until they've signed a RAMS for this job" : "Flag removed — arrival only waits for RAMS that are actually issued");
      onChange && onChange(next);
    } catch (e) { setOn(!next); toast.error(formatApiError(e?.response?.data?.detail) || "Couldn't update"); } finally { setBusy(false); }
  };
  return (
    <label className={`flex items-center gap-2 cursor-pointer rounded-md border px-2.5 py-1.5 ${on ? "border-amber-400 bg-amber-50/70 dark:bg-amber-950/30" : "border-border"}`} data-testid="job-rams-required-toggle">
      <ShieldWarning size={14} className={on ? "text-amber-700 dark:text-amber-300" : "text-muted-foreground"} />
      <span className="text-xs">
        <span className={`font-medium ${on ? "text-amber-900 dark:text-amber-200" : ""}`}>High-risk job — signed RAMS required before arrival</span>
        {!compact && <span className="block text-[11px] text-muted-foreground">Engineers can't press “Arrive on site” until a RAMS naming them is issued and signed, even if none exists yet.</span>}
      </span>
      <Switch checked={on} disabled={busy} onCheckedChange={toggle} className="ml-auto" data-testid="job-rams-required-switch" />
    </label>
  );
}
